<template>
    <div class="profile-container">
        <el-row :gutter="15">
            <el-col :xs="24" :span="12">
                <div class="input-label">نام خانوادگی:</div>
                <el-input placeholder="نام خانوادگی" v-model="user.lastName"></el-input>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">نام:</div>
                <el-input placeholder="نام" v-model="user.firstName"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :xs="24" :span="12">
                <div class="input-label">تلفن ثابت:</div>
                <el-input placeholder="تلفن ثابت" >
                    <template slot="append">
                        <app-telephone-icon/>
                    </template>
                </el-input>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">تلفن همراه:</div>
                <el-input placeholder="تلفن همراه" v-model="user.phoneNumber">
                    <template slot="append">
                        <app-cell-phone-icon/>
                    </template>
                </el-input>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :xs="24" :span="12">
                <div class="input-label">نام کاربری:</div>
                <el-input placeholder="نام کاربری" v-model="user.nickname">
                    <template slot="append">
                        <app-at-sign-icon/>
                    </template>
                </el-input>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">ایمیل:</div>
                <el-input placeholder="ایمیل" v-model="user.email" disabled>
                    <template slot="append">
                        <app-mail-icon/>
                    </template>
                </el-input>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <div class="input-label">آدرس:</div>
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="آدرس">
                </el-input>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-button type="primary" size="medium" disabled>
                    <app-upload-icon/>
                    ذخیره تغییرات
                </el-button>
            </el-col>
        </el-row>

        <el-row :gutter="15" class="change-password-row">

            <el-col :span="24">
                <h3>تغییر رمز عبور</h3>
                <ul>
                    <li>رمز عبور باید حداقل 8 کاراکتر داشته باشد.</li>
                    <li>رمز عبور باید ترکیبی از اعداد و حروف باشد.</li>
                </ul>
            </el-col>

            <el-col :xs="{span: 24, offset: 0}" :span="12" :offset="12">
                <div class="input-label">رمز عبور فعلی:</div>
                <el-input placeholder="رمز عبور فعلی" v-model="currentPassword" show-password></el-input>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">تکرار رمز عبور جدید:</div>
                <el-input placeholder="تکرار رمز عبور جدید" v-model="newPasswordConfirm" show-password></el-input>
            </el-col>

            <el-col :xs="24" :span="12">
                <div class="input-label">رمز عبور جدید:</div>
                <el-input placeholder="رمز عبور جدید" v-model="newPassword" show-password></el-input>
            </el-col>

            <el-col :span="24">
                <el-button type="primary" size="medium" @click="submitNewPassword">
                    ثبت تغییرات
                </el-button>
            </el-col>
            <el-col :span="24">
                <span
                    v-if="resetPasswordStatus.length > 0"
                    :class="{'success': resetPasswordStatus === 'success', 'fail': resetPasswordStatus === 'fail'}">
                    <app-info-icon style="vertical-align:middle"/>
                    {{resetPasswordMessage}}
                </span>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'Profile',
        data() {
            return {
                user: {},
                currentPassword: '',
                newPassword: '',
                newPasswordConfirm: '',
                resetPasswordMessage: '',
                resetPasswordStatus: '',
            }
        },
        created() {
            this.getUserInfo();
        },
        methods: {
            getUserInfo() {
                let userId = JSON.parse(localStorage.getItem('auth')).user._id;

                this.$http.get(`${this.apiURL}/user/${userId}`).then( (response) => {
                    this.user = response.data.user;
                }).catch( (error) => {
                    console.error(error.response.data);
                });
            },
            submitNewPassword() {
                this.$http.put(
                    `${this.apiURL}/user/change-password`,
                    {
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword,
                        newPasswordConfirm: this.newPasswordConfirm
                    }
                ).then( (response) => {
                    console.log(response);
                    this.resetPasswordMessage = 'رمز عبور با موفقیت تغییر یافت!';
                    this.resetPasswordStatus = 'success';
                }).catch( (error) => {
                    console.error(error.response.data);
                    switch (error.response.data.status) {
                        case 1001:
                            this.resetPasswordMessage = 'رمز عبور فعلی اشتباه است!';
                            this.resetPasswordStatus = 'fail';
                            break;
                        case 1002:
                            this.resetPasswordMessage = 'رمز عبور جدید و تکرارش منطبق نیستند!';
                            this.resetPasswordStatus = 'fail';
                            break;
                        case 1003:
                            this.resetPasswordMessage = 'عملیات ناموفق!';
                            this.resetPasswordStatus = 'fail';
                            break;
                        default:
                            break;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .profile-container {
        width: 100%;

        .el-row {
            margin-bottom: 20px;

            .el-col {

                .input-label {
                    font-size: 14px;
                }

                .el-input {
                    direction: ltr;

                    &::v-deep {
                        input {
                            direction: rtl;
                        }

                        .el-input-group__append {

                            svg {
                                vertical-align: text-top;
                            }
                        }
                    }
                }

                .el-button {

                    svg {
                        vertical-align: text-top;
                    }
                }
            }

            &.change-password-row {
                border-radius: 4px;
                border: 1px solid #DCDFE6;

                .el-col {
                    margin-bottom: 20px;

                    ul {
                        padding-right: 19px;
                        font-size: 15px;
                        color: #E99D1A;
                    }

                    span {
                        &.success {
                            color: #388E3C;
                        }
                        &.fail {
                            color: #E53935;
                        }
                    }
                }
            }
        }
    }
</style>
